import {
  SET_TRAINING_TOOLS,
} from '../actions/types';

const defaultState = {
  mainTools: [],
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case SET_TRAINING_TOOLS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
